/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type ESimInfoEsimResetNotAllowedReasonItem =
  (typeof ESimInfoEsimResetNotAllowedReasonItem)[keyof typeof ESimInfoEsimResetNotAllowedReasonItem];

export const ESimInfoEsimResetNotAllowedReasonItem = {
  SimSuspended: "SimSuspended",
  SimInactive: "SimInactive",
  NoMoreActions: "NoMoreActions",
  WrongSimType: "WrongSimType",
  NoAutoRenew: "NoAutoRenew",
  SimNoActivePackage: "SimNoActivePackage",
  SimTerminated: "SimTerminated",
  SimCancelled: "SimCancelled",
  StatusNotAllowed: "StatusNotAllowed",
  SimFixedService: "SimFixedService",
  PackageOrderInProgress: "PackageOrderInProgress",
} as const;
